/* ============================================================================
   Brand marks for UVA Creative Requests.
   RotundaMark — the abstract Rotunda colonnade used on the sign-in panel.
   Wordmark — compact lockup for the app bar.
   ============================================================================ */

export function RotundaMark({
  height = 160,
  navy = 'var(--ink-on-navy)',
  accent = 'var(--uva-orange)',
}: {
  height?: number;
  navy?: string;
  accent?: string;
}) {
  // Abstract, non-photographic evocation of the Rotunda: dome + colonnade + steps.
  return (
    <svg
      height={height}
      viewBox="0 0 220 200"
      fill="none"
      role="img"
      aria-label="UVA Rotunda mark"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Dome */}
      <path d="M110 18c-30 0-52 22-52 50h104c0-28-22-50-52-50z" fill={navy} opacity="0.9" />
      <circle cx="110" cy="20" r="5" fill={accent} />
      {/* Entablature */}
      <rect x="50" y="70" width="120" height="12" rx="2" fill={navy} />
      {/* Pediment accent line */}
      <rect x="50" y="70" width="120" height="3" fill={accent} />
      {/* Colonnade */}
      {[58, 78, 98, 118, 138, 158].map((x) => (
        <rect key={x} x={x} y="86" width="10" height="72" rx="2" fill={navy} opacity="0.88" />
      ))}
      {/* Steps */}
      <rect x="40" y="162" width="140" height="8" rx="2" fill={navy} />
      <rect x="30" y="172" width="160" height="8" rx="2" fill={navy} opacity="0.75" />
      <rect x="20" y="182" width="180" height="8" rx="2" fill={navy} opacity="0.55" />
    </svg>
  );
}

export function Wordmark() {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'baseline',
        gap: 8,
        fontFamily: 'var(--font-display)',
        fontWeight: 600,
        fontSize: '1.05rem',
        letterSpacing: '-0.01em',
        color: 'var(--ink-on-navy)',
      }}
    >
      <span
        aria-hidden
        style={{
          width: 9,
          height: 9,
          borderRadius: 2,
          background: 'var(--uva-orange)',
          display: 'inline-block',
          transform: 'translateY(-1px)',
        }}
      />
      UVA Creative Requests
    </span>
  );
}
